// extracted by mini-css-extract-plugin
export default {"filter":"KatalogItemFilter_filter__QAzvl"};